import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

class ViewConcept extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            noLinks: false,
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.data = {};
        this.data.Concept = null;

        if (this.props.Concept){
            this.data.Concept = this.props.Concept; 
        }

        if (this.props.noLinks){
            this.state.noLinks = this.props.noLinks;
        }


        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.Concept){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json,'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th>
                                <PD.Td>
                                    {(() => {
                                        switch (this.state.noLinks) {
                                            case true:
                                                return json.name
                                            default:
                                                return (
                                                    <PD.PdNavLink to={"/concept/" + json._id} >
                                                        {json.name}
                                                    </PD.PdNavLink>
                                                )
                                        }
                                    })()}
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'notes') &&
                            <PD.Tr>
                                <PD.Th>Notes</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.notes}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.proposals}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'status') &&
                            <PD.Tr>                                
                                <PD.Th>Status</PD.Th><PD.Td>{json.status}</PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'ConceptModel') &&
                            <>
                                <PD.Tr>                                
                                    <PD.Th>Concept Model</PD.Th>
                                    <PD.Td>  
                                        {(() => {
                                            switch (this.state.noLinks) {
                                                case true:
                                                    return json.ConceptModel.name
                                                default:
                                                    return (
                                                        <PD.PdNavLink to={"/conceptmodel/" + json.ConceptModel._id} >
                                                            {json.ConceptModel.name}
                                                        </PD.PdNavLink>
                                                    )
                                            }
                                        })()}
                                    </PD.Td>
                                </PD.Tr>
                                {json.ConceptModel.Owner &&
                                    <PD.Tr>
                                        <PD.Th>Owner</PD.Th><PD.Td>{json.ConceptModel.Owner.organisation}</PD.Td>
                                    </PD.Tr>
                                }
                            </>
                        }


                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.Concept)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewConcept;